import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className="min-h-screen bg-[#F3F5F7] flex items-center justify-center">
      <div className="max-w-md w-full">
        {/* Use Outlet to render the nested route components */}
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
